<template>
  <div class="page">
    <div class="row">
      <div class="sm-12">
        <div class="box-page">
          <div class="row">
            <div class="sm-12">
              <div class="title">
                <i class="mdi mdi-credit-card-check-outline"></i>
                <h2>Conta Corrente</h2>
              </div>
            </div>
          </div>
          <form @submit.prevent.stop="gerar" style="margin-bottom: 20px">
            <div class="row">
              <div class="sm-12 md-6 lg-3">
                <label>
                  Lançamento Boletos
                  <select v-model="formato">
                    <option value="D">Detalhar lanç. boleto</option>
                    <option value="R">Lanç. único por boleto</option>
                  </select>
                </label>
              </div>
              <div class="sm-12 md-6 lg-3">
                <label>
                  Período
                  <select v-model="periodo">
                    <option value="Mês Atual">Mês Atual</option>
                    <option value="Mês Anterior">Mês Anterior</option>
                    <option value="Outro Período">Outro Período</option>
                  </select>
                </label>
              </div>
              <div class="sm-6 lg-3" v-if="periodo == 'Outro Período'">
                <label>
                  De:
                  <input type="date" lang="pt" v-model="data_de" />
                </label>
              </div>
              <div class="sm-6 lg-3" v-if="periodo == 'Outro Período'">
                <label>
                  Até:
                  <input type="date" lang="pt" v-model="data_ate" />
                </label>
              </div>
            </div>
            <div class="row">
              <div class="sm-12 md-6 lg-3">
                <label>
                  SubConta
                  <select v-model="codigo_subconta">
                    <option value="">Todas</option>
                    <option
                      :value="subconta.CodSubConta"
                      v-for="subconta in SubContas"
                      :key="subconta.id">
                      {{ subconta.Descricao }}
                    </option>
                  </select>
                </label>
              </div>
              <div class="sm-12 md-6 lg-3">
                <label>
                  Lançamentos
                  <select v-model="filtro_lancamentos">
                    <option value="">Todos</option>
                    <option value="Somente Débitos">Somente Débitos</option>
                    <option value="Somente Créditos">Somente Créditos</option>
                  </select>
                </label>
              </div>
              <div class="sm-12 md-6 lg-3">
                <label>
                  Layout
                  <select v-model="layout">
                    <option value="Otimizado Dispositivo Móvel">
                      Otimizado Dispositivo Móvel
                    </option>
                    <option value="Visualização Desktop">
                      Visualização Desktop
                    </option>
                  </select>
                </label>
              </div>
              <div class="sm-12 md-6 lg-3">
                <label>
                  <div class="flex align-center">
                    <input type="checkbox" v-model="mostrar_saldo_dia" />

                    Mostra Saldo do Dia
                  </div>
                  &nbsp;
                </label>
              </div>
            </div>
            <div class="row">
              <div class="sm-12 md-6">
                <button class="button secondary" v-if="gerando" disabled>
                  Gerando...
                </button>
                <button class="button secondary" v-else>Gerar extrato</button>
              </div>
              <div class="md-6 text-right visible-md">
                <button
                  class="button secondary full"
                  @click.prevent.stop="printPdf"
                  v-if="
                    movimentacao ||
                    previsao ||
                    subcontas ||
                    previsao_futura ||
                    totalizacao
                  ">
                  {{ gerandoPdf ? "Gerando..." : "PDF" }}
                </button>
                <button
                  class="button secondary visible-md"
                  @click.prevent.stop="print"
                  v-if="
                    movimentacao ||
                    previsao ||
                    subcontas ||
                    previsao_futura ||
                    totalizacao
                  ">
                  Imprimir
                </button>
                <button
                  class="button secondary visible-md"
                  @click.prevent.stop="exportToExcel"
                  v-if="
                    movimentacao ||
                    previsao ||
                    subcontas ||
                    previsao_futura ||
                    totalizacao
                  ">
                  Exportar para Excel
                </button>
              </div>
            </div>
          </form>
          <div ref="resultado"></div>
          <div>
            <MovimentacaoImpressao
              title="Movimentação"
              class="print"
              v-if="Movimentacao"
              :movimentacao="Movimentacao"
              :filtro_lancamentos="filtro_lancamentos"></MovimentacaoImpressao>
            <MovimentacaoImpressao
              title="Previsão de Pagamento"
              class="print"
              v-if="Previsao"
              :movimentacao="Previsao"
              :filtro_lancamentos="filtro_lancamentos"></MovimentacaoImpressao>
            <SubContasImpressao
              class="print"
              v-if="subcontas"
              :subcontas="subcontas"
              :filtro_lancamentos="filtro_lancamentos"></SubContasImpressao>
            <TotalizacaoImpressao
              class="print"
              v-if="totalizacao"
              :totalizacao="totalizacao"
              :filtro_lancamentos="filtro_lancamentos"></TotalizacaoImpressao>
            <PrevisaoFuturaImpressao
              class="print"
              v-if="PrevisaoFutura"
              :movimentacao="PrevisaoFutura"
              :filtro_lancamentos="
                filtro_lancamentos
              "></PrevisaoFuturaImpressao>
          </div>
          <div v-if="layout == 'Visualização Desktop'" class="no-print">
            <div class="row">
              <div class="sm-12">
                <MovimentacaoImpressao
                  title="Movimentação"
                  v-if="Movimentacao"
                  :movimentacao="Movimentacao"
                  :filtro_lancamentos="
                    filtro_lancamentos
                  "></MovimentacaoImpressao>
                <MovimentacaoImpressao
                  title="Previsão de Pagamento"
                  v-if="Previsao"
                  :movimentacao="Previsao"
                  :filtro_lancamentos="
                    filtro_lancamentos
                  "></MovimentacaoImpressao>
                <SubContasImpressao
                  v-if="subcontas"
                  :subcontas="subcontas"
                  :filtro_lancamentos="filtro_lancamentos"></SubContasImpressao>
                <TotalizacaoImpressao
                  v-if="totalizacao"
                  :totalizacao="totalizacao"
                  :filtro_lancamentos="
                    filtro_lancamentos
                  "></TotalizacaoImpressao>
                <PrevisaoFuturaImpressao
                  v-if="PrevisaoFutura"
                  :movimentacao="PrevisaoFutura"
                  :filtro_lancamentos="
                    filtro_lancamentos
                  "></PrevisaoFuturaImpressao>
              </div>
            </div>
          </div>
          <div class="no-print" v-else>
            <Movimentacao
              class="no-print"
              v-if="Movimentacao"
              :movimentacao="Movimentacao"
              :filtro_lancamentos="filtro_lancamentos"></Movimentacao>
            <Previsao
              class="no-print"
              v-if="Previsao"
              :previsao="Previsao"
              :filtro_lancamentos="filtro_lancamentos"></Previsao>
            <SubContas
              class="no-print"
              v-if="subcontas"
              :subcontas="subcontas"
              :filtro_lancamentos="filtro_lancamentos"></SubContas>
            <PrevisaoFutura
              class="no-print"
              v-if="PrevisaoFutura"
              :previsao_futura="PrevisaoFutura"
              :filtro_lancamentos="filtro_lancamentos"></PrevisaoFutura>
            <Totalizacao
              class="no-print"
              v-if="totalizacao && false"
              :filtro_lancamentos="filtro_lancamentos"
              :totalizacao="totalizacao"></Totalizacao>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import ExcelJS from 'exceljs';
import { DateTime } from "luxon";
import Card from "../../components/Card.vue";
import api from "/plugins/api";
import Movimentacao from "./conta-corrente/movimentacao.vue";
import MovimentacaoImpressao from "./conta-corrente/print/movimentacao.vue";
import Previsao from "./conta-corrente/previsao";
import SubContas from "./conta-corrente/subcontas.vue";
import SubContasImpressao from "./conta-corrente/print/subcontas.vue";
import PrevisaoFutura from "./conta-corrente/previsao-futura.vue";
import PrevisaoFuturaImpressao from "./conta-corrente/print/previsao-futura.vue";
import Totalizacao from "./conta-corrente/totalizacao.vue";
import TotalizacaoImpressao from "./conta-corrente/print/totalizacao.vue";
import Swal from "sweetalert2";
import "matchmedia-polyfill";
import "matchmedia-polyfill/matchMedia.addListener";

//import { jsPDF } from 'jspdf'

export default {
  components: {
    Card,
    Movimentacao,
    MovimentacaoImpressao,
    Previsao,
    SubContas,
    SubContasImpressao,
    PrevisaoFutura,
    PrevisaoFuturaImpressao,
    Totalizacao,
    TotalizacaoImpressao,
  },
  data() {
    let layout = "Visualização Desktop";
    if (window.matchMedia("(max-width: 60em)").matches) {
      layout = "Otimizado Dispositivo Móvel";
    }
    return {
      gerando: false,
      gerandoPdf: false,
      error: [],
      subcontas: null,
      movimentacao: null,
      previsao: null,
      filtro_lancamentos: "",
      SubContas: [],
      codigo_subconta: "",
      totalizacao: null,
      previsao_futura: null,
      periodo: "Mês Atual",
      formato: "R",
      data_de: DateTime.local().toFormat("yyyy-LL-dd"),
      data_ate: DateTime.local().toFormat("yyyy-LL-dd"),
      mostrar_saldo_dia: true,
      layout,
    };
  },
  computed: {
    condominio() {
      return this.$store.getters.condominio;
    },
    codigo_condominio() {
      if (!this.condominio) {
        return null;
      }
      return this.condominio.codigo;
    },
    Movimentacao() {
      if (!this.movimentacao) {
        return null;
      }
      let Lancamentos = this.movimentacao.Lancamentos;
      if (this.layout == "Visualização Desktop") {
        Lancamentos = Lancamentos.filter(lancamento => {
          return !lancamento.SaldoDia;
        });
      }
      if (this.filtro_lancamentos != "") {
        Lancamentos = Lancamentos.filter(lancamento => {
          if (this.filtro_lancamentos == "Somente Débitos") {
            return lancamento.ValorDebito != 0;
          } else {
            return lancamento.ValorCredito != 0;
          }
        });
      }
      return {
        ...this.movimentacao,
        Lancamentos,
      };
    },
    Previsao() {
      if (!this.previsao) {
        return null;
      }
      if (this.filtro_lancamentos == "") {
        return this.previsao;
      }
      let Lancamentos = this.previsao.Lancamentos.filter(lancamento => {
        if (this.filtro_lancamentos == "Somente Débitos") {
          return lancamento.ValorDebito != 0;
        } else {
          return lancamento.ValorCredito != 0;
        }
      });
      return {
        ...this.previsao,
        Lancamentos,
      };
    },
    PrevisaoFutura() {
      if (!this.previsao_futura) {
        return null;
      }
      if (this.filtro_lancamentos == "") {
        return this.previsao_futura;
      }
      if (this.filtro_lancamentos == "Somente Débitos") {
        return this.previsao_futura;
      }
      return null;
    },
  },
  methods: {
    print() {
      window.print();
    },
    async exportToExcel() {
      const Workbook = await import("exceljs").then(e => e.Workbook);
      const workbook = new Workbook();
      //const worksheetMovimentacao = workbook.addWorksheet('Movimentação');
      const worksheetMovimentacao = workbook.addWorksheet("Conta Corrente");

      const movimentacoes = this.movimentacao.Lancamentos; // Substitua pelo dado correto

      if (movimentacoes.length > 0) {
        const worksheetMovimentacaoTitulo = worksheetMovimentacao.addRow([
          "Movimentação",
          "",
          "",
          "",
          "",
        ]);
        worksheetMovimentacaoTitulo.font = { bold: true };

        // Aqui você precisará obter os dados que deseja exportar para o Excel

        // Adicionar cabeçalhos
        const titleRowMovimentacao = worksheetMovimentacao.addRow([
          "Data",
          "Histórico",
          "Débito",
          "Crédito",
          "Saldo",
        ]);
        titleRowMovimentacao.font = { bold: true };

        // Adicionar dados
        movimentacoes.forEach(mov => {
          const row = worksheetMovimentacao.addRow([
            DateTime.fromISO(mov.Data).toFormat("dd/LL/yyyy"),
            mov.Descricao,
            -mov.ValorDebito || "",
            mov.ValorCredito || "",
            mov.ValorSaldo || "",
          ]);

          //Define a cor do texto para vermelho na coluna do ValorDebito
          row.getCell(3).font = { color: { argb: "FF0000" } };

          // Verifica se mov.ValorCredito está definido e é negativo
          if (mov.ValorCredito && mov.ValorCredito < 0) {
            row.getCell(4).font = { color: { argb: "FF0000" } }; // ValorCredito na coluna 4
          }
          // Verifica se mov.ValorAtual está definido e é negativo
          if (mov.ValorSaldo && mov.ValorSaldo < 0) {
            row.getCell(5).font = { color: { argb: "FF0000" } }; // ValorSaldo na coluna 5
          }
        });

        // Adicionar o Total ao final das movimentações
        const totalRow = worksheetMovimentacao.addRow([
          "",
          "Total",
          "",
          "",
          "",
        ]);
        totalRow.getCell(2).alignment = { horizontal: "right" }; // Alinhar o texto do "Total" à direita
        totalRow.getCell(3).value = -this.movimentacao.SubTotal.ValorDebito;
        totalRow.getCell(4).value = this.movimentacao.SubTotal.ValorCredito;

        // Define as cores dos valores de débito e crédito
        totalRow.getCell(3).font = {
          color: {
            argb:
              -this.movimentacao.SubTotal.ValorDebito < 0 ? "FF0000" : "337733",
          },
        };
        totalRow.getCell(4).font = {
          color: {
            argb:
              this.movimentacao.SubTotal.ValorCredito < 0 ? "FF0000" : "337733",
          },
        };

        if (this.filtro_lancamentos === "") {
          const saldoCell = totalRow.getCell(5);
          saldoCell.value = this.movimentacao.SubTotal.ValorAtual;
          saldoCell.font = {
            color: {
              argb:
                this.movimentacao.SubTotal.ValorAtual < 0 ? "FF0000" : "337733",
            },
          }; // Define a cor do texto com base no saldo
        }
      }

      /* Previsão de Pagamento */

      const previsoes = this.previsao.Lancamentos;
      if (previsoes.length > 0) {
        //const worksheetPrevisaoPagamento = workbook.addWorksheet('Previsão de Pagamento');
        worksheetMovimentacao.addRow(["", "", "", "", ""]);
        const worksheetPrevisaoPagamento = worksheetMovimentacao.addRow([
          "Previsão de Pagamento",
          "",
          "",
          "",
          "",
        ]);
        worksheetPrevisaoPagamento.font = { bold: true };

        const titleRowPrevisaoPagamento = worksheetMovimentacao.addRow([
          "Data",
          "Histórico",
          "Débito",
          "Crédito",
          "Saldo",
        ]);
        titleRowPrevisaoPagamento.font = { bold: true };

        // Adicionar cabeçalhos
        //const titleRowtPrevisaoPagamento = worksheetPrevisaoPagamento.addRow(['Data', 'Histórico', 'Débito' ,'Crédito' ,'Saldo']);
        //titleRowtPrevisaoPagamento.font = { bold: true };

        // Adicionar dados
        previsoes.forEach(mov => {
          //const row = worksheetPrevisaoPagamento.addRow([
          const row = worksheetMovimentacao.addRow([
            DateTime.fromISO(mov.Data).toFormat("dd/LL/yyyy"),
            mov.Descricao,
            -mov.ValorDebito || "",
            mov.ValorCredito || "",
            mov.ValorSaldo || "",
          ]);

          //Define a cor do texto para vermelho na coluna do ValorDebito
          row.getCell(3).font = { color: { argb: "FF0000" } };

          // Verifica se mov.ValorCredito está definido e é negativo
          if (mov.ValorCredito && mov.ValorCredito < 0) {
            row.getCell(4).font = { color: { argb: "FF0000" } }; // ValorCredito na coluna 4
          }
          // Verifica se mov.ValorAtual está definido e é negativo
          if (mov.ValorSaldo && mov.ValorSaldo < 0) {
            row.getCell(5).font = { color: { argb: "FF0000" } }; // ValorSaldo na coluna 5
          }
        });

        // Adicionar o Total ao final das previsões
        //const totalRowPrevisao = worksheetPrevisaoPagamento.addRow(['', 'Total', '', '', '']);
        const totalRowPrevisao = worksheetMovimentacao.addRow([
          "",
          "Total",
          "",
          "",
          "",
        ]);
        totalRowPrevisao.getCell(2).alignment = { horizontal: "right" }; // Alinhar o texto do "Total" à direita
        totalRowPrevisao.getCell(3).value = -this.previsao.SubTotal.ValorDebito;
        totalRowPrevisao.getCell(4).value = this.previsao.SubTotal.ValorCredito;

        // Define as cores dos valores de débito e crédito no total da previsão
        totalRowPrevisao.getCell(3).font = {
          color: {
            argb: -this.previsao.SubTotal.ValorDebito < 0 ? "FF0000" : "337733",
          },
        };
        totalRowPrevisao.getCell(4).font = {
          color: {
            argb: this.previsao.SubTotal.ValorCredito < 0 ? "FF0000" : "337733",
          },
        };

        if (this.filtro_lancamentos === "") {
          const saldoCellPrevisao = totalRowPrevisao.getCell(5);
          saldoCellPrevisao.value = this.previsao.SubTotal.ValorAtual;
          saldoCellPrevisao.font = {
            color: {
              argb: this.previsao.SubTotal.ValorAtual < 0 ? "FF0000" : "337733",
            },
          }; // Define a cor do texto com base no saldo
        }
      }

      /* Subcontas */
      const subcontas = this.subcontas; // Substitua pelo dado correto
      if (subcontas.length > 0) {
        //const worksheetSubconta = workbook.addWorksheet('Subcontas');
        worksheetMovimentacao.addRow(["", "", "", "", ""]);
        const worksheetSubconta = worksheetMovimentacao.addRow([
          "Subcontas",
          "",
          "",
          "",
          "",
        ]);
        worksheetSubconta.font = { bold: true };

        const titleRowSubconta = worksheetMovimentacao.addRow([
          "Data",
          "Histórico",
          "Débito",
          "Crédito",
          "Saldo",
        ]);
        titleRowSubconta.font = { bold: true };

        // Adicionar cabeçalhos
        //const titleRowtSubconta = worksheetSubconta.addRow(['Subconta', 'Saldo Anterior' ,'Débito' ,'Crédito', 'Saldo Atual']);
        //titleRowtSubconta.font = { bold: true };

        // Adicionar dados
        subcontas.forEach(mov => {
          //const row = worksheetSubconta.addRow([
          const row = worksheetMovimentacao.addRow([
            mov.Descricao,
            mov.ValorAnterior | "",
            -mov.ValorDebito || "",
            mov.ValorCredito || "",
            mov.ValorAtual || "",
          ]);

          // Verifica se mov.ValorAnterior está definido e é negativo
          if (mov.ValorAnterior && mov.ValorAnterior < 0) {
            row.getCell(2).font = { color: { argb: "FF0000" } };
          }

          //Define a cor do texto para vermelho na coluna do ValorDebito
          row.getCell(3).font = { color: { argb: "FF0000" } };

          // Verifica se mov.ValorCredito está definido e é negativo
          if (mov.ValorCredito && mov.ValorCredito < 0) {
            row.getCell(4).font = { color: { argb: "FF0000" } };
          }
          // Verifica se mov.ValorAtual está definido e é negativo
          if (mov.ValorAtual && mov.ValorAtual < 0) {
            row.getCell(5).font = { color: { argb: "FF0000" } };
          }
        });
      }

      /* Totalização */
      //const worksheetTotalizacao = workbook.addWorksheet('Totalização');
      worksheetMovimentacao.addRow(["", "", "", "", ""]);
      const worksheetTotalizacao = worksheetMovimentacao.addRow([
        "Totalização",
        "",
        "",
        "",
        "",
      ]);
      worksheetTotalizacao.font = { bold: true };

      const titleRowTotalizacao = worksheetMovimentacao.addRow([
        "",
        "Saldo Anterio",
        "Débito",
        "Crédito",
        "Saldo",
      ]);
      titleRowTotalizacao.font = { bold: true };

      // Adicionar cabeçalhos
      //const titleRowTotalizacao = worksheetTotalizacao.addRow(['', 'Saldo Anterior', 'Débito', 'Crédito', 'Saldo Atual']);
      //titleRowTotalizacao.font = { bold: true };

      //const totalRowTotalizacao = worksheetTotalizacao.addRow(['', '', '', '', '']);
      const totalRowTotalizacao = worksheetMovimentacao.addRow([
        "",
        "",
        "",
        "",
        "",
      ]);
      // Adicionar os valores
      totalRowTotalizacao.getCell(2).value = this.totalizacao.ValorAnterior;
      totalRowTotalizacao.getCell(3).value = -this.totalizacao.ValorDebito;
      totalRowTotalizacao.getCell(4).value = this.totalizacao.ValorCredito;
      totalRowTotalizacao.getCell(5).value = this.totalizacao.ValorAtual;

      // Define as cores dos valores de acordo com as regras de formatação
      totalRowTotalizacao.getCell(2).font = {
        color: {
          argb: this.totalizacao.ValorAnterior < 0 ? "FF0000" : "337733",
        },
      };
      totalRowTotalizacao.getCell(3).font = {
        color: {
          argb: -this.totalizacao.ValorDebito < 0 ? "FF0000" : "337733",
        },
      };
      totalRowTotalizacao.getCell(4).font = {
        color: {
          argb: this.totalizacao.ValorCredito < 0 ? "FF0000" : "337733",
        },
      };
      totalRowTotalizacao.getCell(5).font = {
        color: { argb: this.totalizacao.ValorAtual < 0 ? "FF0000" : "337733" },
      };

      /* Previsão Futura */
      const previcoesfuturas = this.previsao_futura.Lancamentos; // Substitua pelo dado correto
      if (previcoesfuturas.length > 0) {
        //const worksheetPrevisaoFutura = workbook.addWorksheet('Previsão Futura');
        worksheetMovimentacao.addRow(["", "", "", "", ""]);
        const worksheetPrevisaoFutura = worksheetMovimentacao.addRow([
          "Previsão Futura",
          "",
          "",
          "",
          "",
        ]);
        worksheetPrevisaoFutura.font = { bold: true };

        const titleRowPrevisaoFutura = worksheetMovimentacao.addRow([
          "Data",
          "Histórico",
          "",
          "",
          "Débito",
        ]);
        titleRowPrevisaoFutura.font = { bold: true };

        // Adicionar cabeçalhos
        //const titleRowPrevisaoFutura = worksheetPrevisaoFutura.addRow(['Data', 'Histórico', 'Débito']);
        //titleRowPrevisaoFutura .font = { bold: true };

        // Adicionar dados
        previcoesfuturas.forEach(mov => {
          //const row = worksheetPrevisaoFutura.addRow([
          const row = worksheetMovimentacao.addRow([
            DateTime.fromISO(mov.Data).toFormat("dd/LL/yyyy"),
            mov.Descricao,
            "",
            "",
            -mov.ValorDebito || "",
          ]);

          //Define a cor do texto para vermelho na coluna do ValorDebito
          row.getCell(5).font = { color: { argb: "FF0000" } };
        });

        // Adicionar o Total ao final das previsão futura
        //const totalRowPrevisaoFutura = worksheetPrevisaoFutura.addRow(['', 'Total', '']);
        const totalRowPrevisaoFutura = worksheetMovimentacao.addRow([
          "",
          "",
          "",
          "Total",
        ]);
        totalRowPrevisaoFutura.getCell(4).alignment = { horizontal: "right" }; // Alinhar o texto do "Total" à direita
        totalRowPrevisaoFutura.getCell(5).value =
          -this.previsao_futura.Totalizacao;

        // Define as cores dos valores de débito e crédito
        totalRowPrevisaoFutura.getCell(5).font = {
          color: {
            argb: -this.previsao_futura.Totalizacao < 0 ? "FF0000" : "337733",
          },
        };
      }

      const formattedDateDe = DateTime.fromISO(this.data_de).toFormat(
        "dd-LL-yyyy"
      );
      const formattedDateAte = DateTime.fromISO(this.data_ate).toFormat(
        "dd-LL-yyyy"
      );

      // Generating the filename
      const currentDate = DateTime.local().toFormat("yyyyLLdd");
      const filename = `Conta_Corrente_${formattedDateDe}_${formattedDateAte}_${this.condominio.abrev}_${this.condominio.nome}_${currentDate}.xlsx`;

      // Salvar o arquivo
      workbook.xlsx.writeBuffer().then(buffer => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Criação de um link para download do arquivo
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      });
    },
    async printPdf() {
      try {
        this.gerandoPdf = true;
        //window.print();
        const jsPDF = await import("jspdf").then(e => e.jsPDF);
        const doc = new jsPDF();
        const el = document.querySelector(".page").cloneNode(true);
        el.style.fontFamily = "sans-serif";
        el.querySelectorAll("*").forEach(el => {
          el.style.fontFamily = "sans-serif";
        });
        const divs = el.querySelectorAll(".print");
        divs.forEach(element => {
          element.classList.remove("print");
        });
        el.style.padding = "10mm";
        el.querySelectorAll("td").forEach(el => {
          el.style.padding = "2.5mm";
        });
        el.querySelectorAll(".no-print, form").forEach(el => {
          el.remove();
        });
        el.querySelectorAll(".mdi").forEach(i => {
          i.remove();
        });

        await doc.html(el, {
          width: 190,
          windowWidth: 1024,
          margin: 10,
          html2canvas: {
            windowWidth: 1024,
          },
        });
        doc.save("conta-corrente.pdf");
      } catch (err) {
        console.error(err);
      }
      this.gerandoPdf = false;
    },
    async gerar() {
      try {
        if (!this.codigo_condominio) {
          return;
        }
        this.gerando = true;
        this.errors = [];
        this.movimentacao = null;
        this.previsao = null;
        this.subcontas = null;
        this.totalizacao = null;
        this.previsao_futura = null;

        let params = {
          formato: this.formato,
          mostrar_saldo_dia: this.mostrar_saldo_dia ? 1 : 0,
        };

        if ("" !== this.codigo_subconta) {
          params.codigo_subconta = this.codigo_subconta;
          params = {
            ...params,
            codigo_subconta: this.codigo_subconta,
          };
        }

        let {
          data: {
            Movimentacao,
            Previsao,
            TotalSubContas: SubContas,
            Totalizacao,
            PrevisaoFutura,
          },
        } = await api.get(
          `condominios/${this.codigo_condominio}/conta-corrente/${this.data_de}/${this.data_ate}`,
          {
            params,
          }
        );
        this.movimentacao = Movimentacao;
        this.previsao = Previsao;
        this.subcontas = SubContas;
        this.totalizacao = Totalizacao;
        this.previsao_futura = PrevisaoFutura;

        this.$nextTick(() => {
          this.$refs.resultado.scrollIntoView();
        });
      } catch (err) {
        let text = err.message || "Não foi possível carregar o extrato.";

        if (err.response && err.response.data) {
          text = err.response.data.error;
        }
        Swal.fire({
          icon: "error",
          title: "Oops",
          text,
        });
        console.error(err);
        this.errors = [...this.errors, err];
      }
      this.gerando = false;
    },
    async loadSubcontas() {
      try {
        let { data: subcontas } = await api.get(
          `condominios/${this.codigo_condominio}/subcontas`
        );
        this.SubContas = subcontas;
        let codigos = subcontas.map(({ CodSubConta }) => +CodSubConta);
        if (!codigos.includes(+this.codigo_subconta)) {
          this.codigo_subconta = "";
        }
      } catch (err) {
        console.error(err);
      }
    },
    limpa() {
      this.movimentacao = null;
      this.previsao = null;
      this.subcontas = null;
      this.totalizacao = null;
      this.previsao_futura = null;
    },
  },
  watch: {
    layout(value, old) {
      if (
        value == "Visualização Desktop" &&
        window.matchMedia("(max-width: 60em)").matches
      ) {
        Swal.fire({
          icon: "warning",
          title: "Aviso",
          text: "Melhor visualizado com o dispositivo móvel na horizontal",
        });
      }
    },
    periodo: {
      immediate: true,
      handler(value) {
        let first_date;
        switch (value) {
          case "Mês Atual":
            first_date = DateTime.local();
            first_date = first_date.set({ day: 1 });

            this.data_de = first_date.toFormat("yyyy-LL-dd");
            this.data_ate = first_date
              .plus({ months: 1 })
              .minus({ days: 1 })
              .toFormat("yyyy-LL-dd");
            break;
          case "Mês Anterior":
            first_date = DateTime.local();
            first_date = first_date.set({ day: 1 }).minus({ months: 1 });

            this.data_de = first_date.toFormat("yyyy-LL-dd");
            this.data_ate = first_date
              .plus({ months: 1 })
              .minus({ days: 1 })
              .toFormat("yyyy-LL-dd");
            break;
          default:
            break;
        }
        this.limpa();
      },
    },
    data_de() {
      this.limpa();
    },
    data_ate() {
      this.limpa();
    },
    formato() {
      this.limpa();
    },
    codigo_subconta() {
      this.limpa();
    },
    mostrar_saldo_dia() {
      this.limpa();
    },
    codigo_condominio: {
      immediate: true,
      handler() {
        this.loadSubcontas();
      },
    },
  },
  created() {
     this.gerar()
  },
};
</script>
<style lang="less">
@import "../../css/colors.less";
</style>
<style lang="less" scoped>
.text-green {
  color: var(--green);
}
.text-red {
  color: var(--red);
}
label {
  display: inline-block;
  width: 100%;
  position: relative;
  input[type="date"]::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    color: transparent;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
  }
  @media screen and (min-width: 40em) {
    .flex {
      padding-top: 2em;
    }
  }
  [type="checkbox"] {
    width: 1em;
    height: 1em;
  }
}

.print {
  margin: 2em;
}
</style>
